module.exports = __webpack_public_path__ + "static/pool-cover-52af3c5b40bb47b118284800f014661b.jpg";